module.exports = __webpack_public_path__ + "static/media/cat.46753f66.svg";